{
  "es": {
    "company": {
      "actions": {
        "changeCompany": "Cambiar empresa",
        "searchCompany": "Buscar empresa"
      },
      "attributes": {
        "address": "Dirección",
        "email_address": "Correo electrónico",
        "iban": "IBAN",
        "language": "Idioma",
        "name": "Nombre de la empresa",
        "phone": "Teléfono",
        "subdomain": "Subdominio",
        "vat": "IVA"
      },
      "labels": {
        "company": "Empresa",
        "contact": "Contacto",
        "contacts": "Contactos",
        "language": "Este es el idioma predeterminado de la empresa para tu página de inicio de sesión, los clientes y los empleados.",
        "or": "O"
      },
      "validation": {
        "contactAlreadyExist": "El contacto ya existe. Selecciónalo en el desplegable.",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "needName": "El nombre es obligatorio"
      }
    }
  }
}
